<template>
    <section id="long-stay">
        <div class="long-stay-images">
            <img src="/img/long-stay/long-stay.jpg" alt="">
        </div>
        <div class="long-stay-content">
            <div class="content">
                <h2 class="title">{{$t('longStaySection.title')}}</h2>
                <p class="text">
                    {{$t('longStaySection.text1')}}
                </p>
                <p class="text">
                    {{$t('longStaySection.text2')}}
                </p>
                <div class="learn-more content-buttons">
                    <a href="#modal_long_stay" class="learn-btn open-modal btn-desktop">{{$t('longStaySection.moreBtn')}}</a>

                    <div class="m-buttons-wrap">
                        <a href="#modal_long_stay" @click="changeButtonText()" class="learn-btn open-modal border-btn">
                          {{details_opened ? $t('buttons.hide') : $t('longStaySection.moreBtn')}}
                        </a>
                    </div>
                    <div class="accordion">
                        <div class="info">
                            <h2 class="title">{{$t('longStaySection.title')}}</h2>
                            <p class="content-description">{{$t('longStayModal.p1')}}</p>
                            <p class="content-description">{{$t('longStayModal.p2')}}</p>
                            <p class="content-description">{{$t('longStayModal.p3')}}</p>
                            <p class="content-description">{{$t('longStayModal.p4')}}</p>
                            <p class="content-description">{{$t('longStayModal.p5')}}</p>
                            <p class="content-description">{{$t('longStayModal.p6')}}</p>
                            <p class="content-description">{{$t('longStayModal.p7')}}</p>
                            <p class="content-description">{{$t('longStayModal.p8')}}</p>
                            <ul>
                              <li class="content-description">{{$t('longStayModal.p9')}}</li>
                              <li class="content-description">{{$t('longStayModal.p10')}}</li>
                              <li class="content-description">{{$t('longStayModal.p11')}}</li>
                            </ul>
                            <p class="content-description">{{$t('longStayModal.p12')}}</p>
                            <p class="content-description">{{$t('longStayModal.p13')}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name:'LongStay',
        data() {
          return {
            details_opened: false
          }
        },
        methods: {
          changeButtonText() {
            this.details_opened = !this.details_opened;
          }
        }
    }
</script>
